import { defineComponent as _defineComponent } from 'vue';
import { useAuth } from '@/plugins/auth';
import { useTelemetry } from '@/plugins/telemetry';
import { useStore } from '@/store/useStore';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'quota-option',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var store = useStore();
    var auth = useAuth();
    var telemetry = useTelemetry();
    var route = useRoute();
    var plan = auth.user.labsWandhPlan;
    var showStandardModelRemainingQuota = !!plan && plan.maxSearchTotal !== null;
    var quota = computed(function () {
      return store.state.persistent.labs.wandh.quota;
    });
    var standardModelRemainingQuota = computed(function () {
      var _quota$value$remainin, _quota$value, _quota$value$remainin2;
      return (_quota$value$remainin = (_quota$value = quota.value) === null || _quota$value === void 0 ? void 0 : (_quota$value$remainin2 = _quota$value.remainingQuotaByModel.standard.remainingQuota) === null || _quota$value$remainin2 === void 0 ? void 0 : _quota$value$remainin2.toLocaleString()) !== null && _quota$value$remainin !== void 0 ? _quota$value$remainin : '0';
    });
    var allocatedQuota = computed(function () {
      var _auth$user$labsWandhP, _auth$user$labsWandhP2, _auth$user$labsWandhP3;
      return (_auth$user$labsWandhP = (_auth$user$labsWandhP2 = auth.user.labsWandhPlan) === null || _auth$user$labsWandhP2 === void 0 ? void 0 : (_auth$user$labsWandhP3 = _auth$user$labsWandhP2.maxSearchTotal) === null || _auth$user$labsWandhP3 === void 0 ? void 0 : _auth$user$labsWandhP3.toLocaleString()) !== null && _auth$user$labsWandhP !== void 0 ? _auth$user$labsWandhP : '0';
    });
    var handleTicketTooltipClick = function handleTicketTooltipClick() {
      telemetry.sendClickTelemetry({
        button: 'wandh-input-form__ticket-tooltip'
      }, route);
    };
    var hasRemainingQuota = computed(function () {
      var _quota$value2, _quota$value3;
      return (
        // nullの場合は無制限なので常にtrue
        !!plan && plan.maxSearchTotal === null || quota.value && ((_quota$value2 = quota.value) === null || _quota$value2 === void 0 ? void 0 : _quota$value2.remainingQuotaByModel.standard.remainingQuota) !== null && ((_quota$value3 = quota.value) === null || _quota$value3 === void 0 ? void 0 : _quota$value3.remainingQuotaByModel.standard.remainingQuota) > 0
      );
    });
    expose({
      hasRemainingQuota: hasRemainingQuota
    });
    return {
      __sfc: true,
      store: store,
      auth: auth,
      telemetry: telemetry,
      route: route,
      plan: plan,
      showStandardModelRemainingQuota: showStandardModelRemainingQuota,
      quota: quota,
      standardModelRemainingQuota: standardModelRemainingQuota,
      allocatedQuota: allocatedQuota,
      handleTicketTooltipClick: handleTicketTooltipClick,
      hasRemainingQuota: hasRemainingQuota
    };
  }
});